import React from "react";

const NotFound = () => (
  <div
    style={{
      margin: "auto",
      width: "50%",
      padding: "10px"
    }}>
    <h1>You've found a page that doesn't exist!</h1>
    <h3>
      Lars has a special message for you:
    </h3>
    <img src="/images/eggs/notfound.gif" style={{display: 'block', marginLeft: 'auto', marginRight: 'auto'}} />
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js